import type { ChartViewEDProps } from "../types";
import { aggregateModelCreatorORM } from "@certa/common/modelCreators";
import { INDEX_ZERO } from "@certa/common/constants";

type Props = Pick<ChartViewEDProps, "apiData" | "chartConfigED">;

export const useConvertToChartDataED = (props: Props) => {
  const { apiData, chartConfigED } = props;
  const { isStackedBarChart, isGroupedBarChart } =
    chartConfigED.otherConfigurations;

  const yAxis = chartConfigED.operations.filter(
    operation => operation.extraJSON.axisName === "yAxis"
  );

  const outputDataTypes = yAxis.map(
    operation => operation.extraJSON.outputDataType
  );

  const xAxisLength = chartConfigED.groupBy.length;
  const xAxisKey = chartConfigED.groupBy[INDEX_ZERO].extraJSON.label;

  const reportChartData = aggregateModelCreatorORM(
    isStackedBarChart && !isGroupedBarChart,
    outputDataTypes,
    xAxisLength,
    xAxisKey
  )(apiData);

  return reportChartData;
};
